import { takeLatest, call, put, select } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import factory from "utils/getApiHandlerEffect";

import { selectUserCidpId } from "scenes/selectors";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  onLoading,
  onLoad,
  onDelete,
  onRemoveLoading,
  onPasswordValidate,
  onPasswordValidateSuccess,
} from "./redux";

export function* onLoadAuthenticatorList(): SagaIterator<void> {
  const cidpId = yield select(selectUserCidpId);
  const apiHandler: APIHandler = yield call(() => factory());

  try {
    const appAuthData: any = yield call(() =>
      apiHandler.getAuthenticatorList(cidpId)
    );

    yield put(onLoad(appAuthData.authenticators));
  } catch (e: any) {
    if (e.statusCode === 400) {
      yield put(onLoad(null));
    }
    yield put(onLoad(null));
  }
}

export function* onRemoveAuthenticator(
  action: PayloadAction<any>
): SagaIterator<void> {
  const type = action.payload;
  const cidpId = yield select(selectUserCidpId);
  const apiHandler: APIHandler = yield call(() => factory());

  try {
    const appAuthData: any = yield call(() =>
      apiHandler.deleteMfaAuthenticator(type, cidpId)
    );
    if (appAuthData) {
      yield put(onDelete(true));
    }
  } catch (e: any) {
    if (e.statusCode === 400) {
      yield put(onDelete(false));
    }
    yield put(onDelete(false));
  }
}

export function* onUserAuthentication(
  action: PayloadAction<any>
): SagaIterator<void> {
  const password = action.payload;
  const cidpId = yield select(selectUserCidpId);
  const apiHandler: APIHandler = yield call(() => factory());

  try {
    const appAuthData: any = yield call(() =>
      apiHandler.userAuthentication(cidpId, password)
    );
    if (appAuthData) {
      yield put(onPasswordValidateSuccess(true));
    }
  } catch (e: any) {
    yield put(onPasswordValidateSuccess(false));
  }
}

// watcher function
export default function* dashboardMfaSetupSaga() {
  yield takeLatest(onLoading.type, onLoadAuthenticatorList);
  yield takeLatest(onRemoveLoading.type, onRemoveAuthenticator);
  yield takeLatest(onPasswordValidate.type, onUserAuthentication);
}
